import type { LucideIconData } from 'lucide-angular';
import {
  AlertCircle,
  ArrowDown,
  ArrowRight,
  ArrowUp,
  ArrowUpRight,
  Building2,
  Calendar,
  CalendarMinus,
  ChartColumn,
  Check,
  CheckCircle2,
  ChevronDown,
  CircleAlert,
  CirclePause,
  CircleX,
  CloudUpload,
  Download,
  Eye,
  File,
  FileImage,
  Filter,
  Image,
  Inbox,
  Info,
  LogOut,
  LucideAngularModule,
  Minus,
  Paperclip,
  PlusCircle,
  Search,
  Settings,
  Sparkles,
  Table,
  Trash2,
  Undo2,
  User,
  Users,
  X,
} from 'lucide-angular';

export { LucideAngularModule };

export const CoreIcons = {
  alertCircle: AlertCircle,
  arrowDown: ArrowDown,
  arrowRight: ArrowRight,
  arrowUp: ArrowUp,
  arrowUpRight: ArrowUpRight,
  building2: Building2,
  calendar: Calendar,
  calendarMinus: CalendarMinus,
  chartColumn: ChartColumn,
  check: Check,
  checkCircle2: CheckCircle2,
  chevronDown: ChevronDown,
  circleAlert: CircleAlert,
  circlePause: CirclePause,
  circleX: CircleX,
  cloudUpload: CloudUpload,
  download: Download,
  eye: Eye,
  file: File,
  fileImage: FileImage,
  filter: Filter,
  image: Image,
  inbox: Inbox,
  info: Info,
  logOut: LogOut,
  minus: Minus,
  paperclip: Paperclip,
  plusCircle: PlusCircle,
  search: Search,
  settings: Settings,
  sparkles: Sparkles,
  table: Table,
  trash2: Trash2,
  undo2: Undo2,
  user: User,
  users: Users,
  x: X,
} as const;

export type CoreIcon = LucideIconData;
